import { AuthConfig } from "angular-oauth2-oidc";
const oidc_config: AuthConfig = {
  issuer: "https://auth.rc.myviewboard.com/oidc/v1",

  redirectUri: window.location.origin + "/preview/home",

  clientId: "mvb-core-service",

  responseType: "code",

  scope: "openid profile email",

  showDebugInformation: true,
  timeoutFactor: 0.8
};
export const environment = {
  production: false,
  apiUrl: "https://api.rc.myviewboard.com",
  apiv2Url: "https://api.rc.myviewboard.com",
  sensApiUrl: "https://sens.rc.myviewboard.com",
  mqttUrl: "https://control.myviewboard.com",
  authUrl: "https://auth.rc.myviewboard.com",
  extensionId: "bflolcmnokpcochfhappdfipeficedjf",
  appInsights: { instrumentationKey: "f04ac989-013d-48d6-997e-386b04280e72" },
  pathTo_HostBoard: "/classroom/teacher",
  pathTo_JoinBoard: "/classroom/student",
  dcUrl: "https://insight.myviewboard.cloud",
  dmUrl: "https://myviewboard.com/mydashboard/dm",
  imUrl: "https://myviewboard.com/mydashboard/im",
  clipsUrl: "https://rc.myviewboardclips.com",
  originalsUrl: "https://rc.myviewboard.com/originals",
  isLiveChat: true,
  isGA: true,
  subUrl: "https://subscription.rc.myviewboard.com",
  mspUrl: "https://msp.rc.myviewboard.com",
  oidc_config,
  domainURL: ".rc.myviewboard.com",
  communityUrl: "https://community.myviewboard.com"
};
